import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    badge: {
      '& .MuiBadge-badge': {
        right: '2px',
        top: '13px',
        padding: theme.spacing(0, 0.5),
      },
    },
    avatar: {
      marginLeft: '5px',
    },
    avatarOld: {
      borderRadius: '2px',
      width: '36px',
      height: '36px',
      boxShadow: '0 3px 6px rgb(0 0 0 / 18%)',
      marginRight: '6px',
    },
    clockIcon: {
      marginRight: '5px',
      padding: '3px',
      color: '#05A4D8',
    },
    userIcon: {
      marginLeft: '10px',
      color: '#05A4D8',
    },
    listItemAvatarOld: { minWidth: 'auto' },
    listItemRoot: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      textTransform: 'initial',
      '&:hover': {
        backgroundColor: 'inherit',
      },
    },
    listItemTextMultiline: {
      '&.MuiListItemText-multiline': {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    listItemTextPrimary: {
      fontSize: theme.typography.body2.fontSize,
    },
    listItemTextSecondary: {
      fontSize: theme.typography.caption.fontSize,
    },
    listItemTextSecondaryOldUi: {
      fontSize: '0.875rem',
      color: '#111',
    },
    listItemTextEmployee: {
      fontSize: '0.82rem',
      color: 'black',
    },
  };
};
